'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var makePropertyFullAddress = function makePropertyFullAddress(property, locale) {
  var propertyAddress = (0, _get2.default)(property, 'data.address');
  var localizedAddress = (0, _get2.default)(propertyAddress, locale) || (0, _get2.default)(propertyAddress, 'en');
  var streetName = (0, _get2.default)(localizedAddress, 'street_name');
  var houseNumber = (0, _get2.default)(localizedAddress, 'house_number');
  var city = (0, _get2.default)(localizedAddress, 'city_name');

  if (!city || !streetName) return null;

  if (!houseNumber) {
    return streetName + ', ' + city;
  }
  return streetName + ' ' + houseNumber + ', ' + city;
};exports.default =

makePropertyFullAddress;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertyDetailedContactsUsForm/helpers.js
// module id = 3020
// module chunks = 0